import { createAsyncThunk } from '@reduxjs/toolkit';
import { postRequest, getRequest, putRequest } from '../../../axios/requests';
import API from '../../../constant.api';

export const createNewSale = createAsyncThunk(
  'sale/create',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.SALES, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const searchSaleNumbers = createAsyncThunk(
  'sale/search',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await getRequest(`${API.SALES}/saleNumber/${payload}`, {});

      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const searchClosedSaleNumbers = createAsyncThunk(
  'sale/searchClosed',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await getRequest(`${API.SALES}/closed/saleNumber/${payload}`, {});

      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSaleTypes = createAsyncThunk(
  'sale/get',
  async (payload: any, { rejectWithValue }) => {
    try {
      const metalRes = await getRequest(API.METALS, {});

      return {
        metals: metalRes.data
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSaleBySaleNumber = createAsyncThunk(
  'sale/getSale',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await getRequest(`${API.SALES}/saleNumber/${payload}`,{});

      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUnpledgedSales = createAsyncThunk(
  'sales/unpledged',
  async (payload: {branch: string}, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(
        `${API.SALES}/list/unpledged`, payload
      )
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUndisbursedSales = createAsyncThunk(
  'sales/undisbursed',
  async (payload: null, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(
        `${API.SALES}/list/undisbursed`, payload
      )
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUndisbursedSale = createAsyncThunk(
  'sale/update',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await putRequest(`${API.SALES}/undisbursed/${payload.id}`, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUnsettledSalePayments = createAsyncThunk(
  'sale-payments/unsettled',
  async (payload: null, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(
        `${API.SALE_PAYMENTS}/list/unsettled`, payload
      )
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUnapprovedSalePayments = createAsyncThunk(
  'sale-payments/unapproved',
  async (payload: null, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(
        `${API.SALE_PAYMENTS}/list/approvals`, payload
      )
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUnsettledSalePayment = createAsyncThunk(
  'sale-payments/update',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await putRequest(`${API.SALE_PAYMENTS}/${payload.id}`, {status: payload.status});
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSalePaymentSplit = createAsyncThunk(
  'sale-payments/updateSplit',
  async (
    payload: { id: string; onlinePrincipal: number; offlinePrincipal: number },
    { rejectWithValue }
  ) => {
    try {
      const res = await putRequest(`${API.SALE_PAYMENTS}/split/${payload.id}`, {
        onlinePrincipal: payload.onlinePrincipal,
        offlinePrincipal: payload.offlinePrincipal,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUnapprovedSales = createAsyncThunk(
  'sales/unapproved',
  async (payload: null, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(
        `${API.SALES}/list/unapproved`, payload
      )
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUnapprovedSale = createAsyncThunk(
  'sale/approval',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await putRequest(`${API.SALES}/approval/${payload.id}?status=${payload.status}`, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSalePrincipal = createAsyncThunk(
  'sale/updatePrincipal',
  async (payload: { id: string; onlinePrincipal?: number; offlinePrincipal?: number }, { rejectWithValue }) => {
    try {
      const res = await putRequest(`${API.SALES}/principal/${payload.id}`, {
        onlinePrincipal: payload.onlinePrincipal,
        offlinePrincipal: payload.offlinePrincipal,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createSalePayment = createAsyncThunk(
  'sale/payment',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.SALE_PAYMENTS, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
